"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_hooks_1 = require("@apollo/react-hooks");
const use_query_params_1 = require("use-query-params");
const react_router_dom_1 = require("react-router-dom");
// eslint-disable-next-line no-use-before-define
const react_1 = __importDefault(require("react"));
const AssertionInfosView_1 = __importDefault(require("../../assertion/AssertionInfosView"));
const AssertionInfoView_1 = __importDefault(require("../ui/assertion/AssertionInfoView"));
function CenterAssertManagement({ path, client, }) {
    return (react_1.default.createElement(react_hooks_1.ApolloProvider, { client: client },
        react_1.default.createElement(use_query_params_1.QueryParamProvider, { ReactRouterRoute: react_router_dom_1.Route },
            react_1.default.createElement(react_router_dom_1.Switch, null,
                react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: path, component: (args) => react_1.default.createElement(AssertionInfosView_1.default, Object.assign({ rootPath: path }, args, { canDisplayCost: true })) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: `${path}/:id`, component: (args) => react_1.default.createElement(AssertionInfoView_1.default, Object.assign({ rootPath: path }, args, { canDisplayCost: true })) })))));
}
exports.default = CenterAssertManagement;
